<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入品牌名称进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
      <div>
        <el-button
          type="primary"
          @click="event().toAddOrEditClick()">
          新建品牌
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      border
      :data="tableData">
      <el-table-column
        prop="brand_no"
        label="品牌编号"/>
      <el-table-column
        prop="priority"
        label="排序"/>
      <el-table-column
        prop="name"
        label="品牌名称"/>
      <el-table-column
        prop="official_url"
        label="官网链接"/>
      <el-table-column
        prop="avatar"
        label="logo"
        width="161">
        <template slot-scope="scope">
          <img
            :src="imgDomain+'/'+scope.row.logo_src"
            height="40px">
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="330">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().onDelClick(scope.row.uuid)">
            删除
          </el-button>
          <el-button
            size="mini"
            type="primary"
            class="mini-el-button"
            @click="event().toAddOrEditClick(scope.row.uuid)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>
  </el-main>
</template>

<script>
import { getBrandList as list_api, deleteBrand as del_api } from '../../api/content'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'
import {delCommoddity} from "../../api/commodity";

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
    };
  },

  components: {
  },
  created() {
    this.network().getList()
  },
  methods: {
    handleCurrentChange() {
      this.network().getList()
    },
    search() {
      this.network().getList()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
        },
        toAddOrEditClick: (uuid) => {
          this.$router.push({ path: 'brand-add', query: { uuid } })
        },
        onDelClick: async (uuid) => {
          this.$confirm('确定删除商品, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.network().del(uuid)
              .then(() => {
                if (this.tableData.length === 1 && this.total > 10) {
                  this.body.page_index = this.body.page_index - 1
                }
              })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
        },
      }
    },
    network() {
      return {
        del: async (uuid) => {
          const { status } = await del_api(uuid)
          if (status !== 200) return
          this.network().getList()
          this.$notify({
            title: '删除成功',
            message: '删除成功',
            type: 'success',
          });
        },
        getList: async () => {
          const { status, data } = await list_api(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/brand/list.vue